import React from 'react'
// import './page.css'
import styled from 'styled-components';

function page() {
  return (
    <>
      {/* <div className="content"> */}
      {/* <svg viewBox="0 0 960 300">
          <symbol id="s-text">
            <text textAnchor="middle" x="50%" y="50%">
              page not found
            </text>
          </symbol>

          <g className="g-ants">
            <use xlinkHref="#s-text" className="text"></use>
            <use xlinkHref="#s-text" className="text"></use>
            <use xlinkHref="#s-text" className="text"></use>
            <use xlinkHref="#s-text" className="text"></use>
            <use xlinkHref="#s-text" className="text"></use>
          </g>
        </svg> */}

      {/* </div> */}
      <div className="containt-center">
       <h2> Page Not Found </h2>
        </div>
    </>
  );
}

export default page
const NotFoundContainer = styled.div`
  .content {
    margin: 0;
    padding: 0;
    font-weight: 800;
    box-sizing: border-box;
    background: #000;
    font-family: cursive;
  }

  .containt-center {
    text-align: center;
    justify-content: center;
    /* height: 100%; */
    margin: 200px;
  }

  svg {
    font: 10.5em "Monoton";
    width: 70%;
    height: 100vh;
  }

  .content {
    text-align: center;
  }

  /* h1 {
    text-align: center;
    font: 1.5em 'Roboto', sans-serif;
    font-weight: bold;
    color: #2f8f7f;
    opacity: .6;
} */

  /* a {
    display: inline-block;
    text-transform: uppercase;
    font-size: 1em 'Roboto';
    font-weight: 300;
    border: 1px solid #2f8f7f;
    border-radius: 4px;
    color: #2f8f7f;
    margin: 15px 0;
    padding: 8px 14px;
    text-decoration: none;
    opacity: .6;
} */

  .text {
    fill: none;
    stroke-dasharray: 8% 29%;
    stroke-width: 13px;
    stroke-dashoffset: 1%;
    animation: stroke-offset 5.5s infinite linear;
  }

  .text:nth-child(1) {
    stroke: #1c234d;
    animation-delay: -1;
  }

  .text:nth-child(2) {
    stroke: #315b2c;
    animation-delay: -2s;
  }

  .text:nth-child(3) {
    stroke: #ffcc00;
    animation-delay: -3s;
  }

  .text:nth-child(4) {
    stroke: #2f8f7f;
    animation-delay: -4s;
  }

  .text:nth-child(5) {
    stroke: #da2717;
    animation-delay: -5s;
  }

  @keyframes stroke-offset {
    100% {
      stroke-dashoffset: -35%;
    }
  }
`;

